const styles = (theme) => ({
  headerLabel: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.TextColor,
    opacity: 0.6,
    marginTop: 8,
  },
  fullWidth: { width: "100%" },
  countryDetailWidth: { width: "49%" },
  hazmatContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: 8,
  },
  inputClass: {
    paddingLeft: "10px",
  },
  inputRowWarning: {
    border: `1px solid ${theme.inputWarningLabelColor}`,
    padding: 8,
  },
  inputRowWarningTextColor: {
    fontSize: 12,
    color: theme.warningTextColor,
  },
});

export default styles;
